import { useQuery } from "@apollo/client";
import { useState } from "react";
import { Table } from "reactstrap";
import { GET_ADMIN_QUERIES } from "../../../graphql/valuelist-gql";
import { IValueListAdminQuery, IValueListQueriesResponse } from "../../../types/valuelist";
import "./style.scss";
import SpinnerOverlay from "../../common/spinner/spinner";

const SavedQueriesTable = (props: {
  onSelect: (query: IValueListAdminQuery | undefined) => void;
}) => {
  const { onSelect } = props;
  const [selectedItem, setSelectedItem] = useState<IValueListAdminQuery>();
  const { data, loading } = useQuery<IValueListQueriesResponse>(GET_ADMIN_QUERIES);

  function rowClicked(query: IValueListAdminQuery) {
    if (query.id === selectedItem?.id) return;
    setSelectedItem(query);
    onSelect(query);
  }

  return loading ? <SpinnerOverlay /> : (
    <section
      className="overflow-y-auto scrollable-query-list"
    >
      <Table
        striped hover
        aria-colcount={1}
        aria-label="Saved Queries table"
        aria-rowcount={data?.getAdminQueries?.length ?? 0}
        tabIndex={0}
      >
        <thead>
          <tr>
            <th scope="col">Query Title</th>
          </tr>
        </thead>
        <tbody>
          {data?.getAdminQueries.map((query, index) => {
            const isSelected = query.id === selectedItem?.id;
            return (
              <a
                key={query.id}
                role="row"
                aria-rowindex={index + 1}
                aria-setsize={data?.getAdminQueries?.length}
                aria-selected={isSelected}
                className={isSelected ? "table-primary" : "pe-force action-link"}
                // allows NVDA screenreader to move screenreader focus to each row element
                href="#"
                // role="grid" was removed as JAWS would get stuck on an element when selected; this lets NVDA read the row names properly in its stead
                aria-label={query.label}
                // keeps NVDA focus from getting stuck on an element when selected
                onClick={(e) => { e.preventDefault(); rowClicked(query); }}
                tabIndex={0}
              >
                <td>{query.label}</td>
              </a> 
            );
          })}
        </tbody>
      </Table>
    </section>
  );
};

export default SavedQueriesTable;
